module.exports = __webpack_public_path__ + "img/Norske-folkeeventyr_Bildet-av-boken-Folke-og-Huldre-Eventyr.3ddd663b.jpg";